import { useState, useEffect, useCallback } from 'react';
import { toast } from 'sonner';
import { getBrandName } from '@/lib/branding';

// Shared PWA install-prompt state. Captures the browser's `beforeinstallprompt`
// event so any component (sidebar icon, etc.) can offer "Install app".
export default function useInstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setInstallEvent(e); };
    const onInstalled = () => setInstallEvent(null);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const install = useCallback(async () => {
    if (!installEvent) return;
    installEvent.prompt();
    try {
      const { outcome } = await installEvent.userChoice;
      if (outcome === 'accepted') toast.success(`Installing ${getBrandName()}…`);
    } catch (_) { /* dismissed */ }
    setInstallEvent(null);
  }, [installEvent]);

  return { canInstall: !!installEvent, install };
}
